export default {
	install(_this, options){
		_this.prototype.version = '1.0.1'
	}
}
